var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import "@frameworks/shared-library/stylesheets/components/OrderBookSideBar/OrderBookFooter.scss";
import { nanoid } from "nanoid";
var OrderBookFooter = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), showPopup = _d[0], setShowPopup = _d[1];
    var uniqueMoreDetailsSectionId = nanoid();
    return (props === null || props === void 0 ? void 0 : props.btnDetails) ? (React.createElement("div", { className: "d-flex justify-content-end align-items-center w-100 orderbook__footer__container" },
        ((_a = props.btnDetails) === null || _a === void 0 ? void 0 : _a.label) && (React.createElement(EdButton, { btnTyp: "tomato", value: props.btnDetails.label, className: "ob-footer-btn", onClick: function (e) {
                return props.handleOrderbookFooterCTAClick(e.currentTarget.innerText);
            }, disabled: showPopup })),
        ((_c = (_b = props.btnDetails) === null || _b === void 0 ? void 0 : _b.moreDetails) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (React.createElement(GenericPopup, { children: React.createElement("div", { className: "more-actions flex-column flexCenter" }, props.btnDetails.moreDetails.map(function (item, index) {
                return (React.createElement("div", { className: "more-action-item displayFlex", key: index, role: "button", onClick: function (e) {
                        return props.handleOrderbookFooterCTAClick(e.currentTarget.innerText);
                    } },
                    React.createElement("i", { className: item.icon }),
                    React.createElement("label", { className: "DMSanN_14_400" }, item.text)));
            })), placement: "top", button: React.createElement("div", { className: "more-details" },
                React.createElement("span", { id: uniqueMoreDetailsSectionId, className: showPopup
                        ? "edel-icon-cross-bold-small"
                        : "edel-icon-kabab-menu" })), buttonOnClick: function () { return setShowPopup(!showPopup); }, setIsShow: setShowPopup, parentClass: "ob-sidebar-dropdown-container", containerDom: function () {
                return document.getElementById(uniqueMoreDetailsSectionId);
            }, isHeadline: true, removeTooltipArrow: true })) : (""))) : (React.createElement(React.Fragment, null));
};
export default OrderBookFooter;
